import { AdminLayout } from './AdminLayout'
import { UserLayout } from './UserLayout'
import { useAuthStore } from '../../stores/authStore'

/**
 * Layout wrapper that picks the right chrome (sidebar + header) based
 * on the signed-in user's role. Used by routes that present the SAME
 * page content to multiple roles but want each role to keep its
 * familiar nav rail.
 *
 * In particular: the Spaces UX (SpacePage + Board + Documents +
 * Calendar) is now shared by employees, Sub Admins and Company Admins.
 * Employees see their `UserLayout` sidebar with personal workspaces;
 * admins see their `AdminLayout` sidebar with administration shortcuts
 * + a tenant-wide Spaces tree. The page in the outlet stays the same.
 *
 * Role mapping
 * ------------
 *   company_admin / sub_admin  → AdminLayout
 *   user (and any fallback)    → UserLayout
 *   super_admin                → UserLayout (super_admin never hits
 *                                /app/* URLs in practice; if they do,
 *                                fall back to the safer user shell
 *                                rather than admin chrome)
 *
 * The actual `<Outlet />` lives inside AdminLayout / UserLayout — this
 * component is a pure dispatcher and renders no DOM of its own.
 */
export function RoleAwareLayout() {
  const role = useAuthStore((s) => s.user?.role)
  if (role === 'company_admin' || role === 'sub_admin') {
    return <AdminLayout />
  }
  return <UserLayout />
}
